import StaffRepository from './staffRepository';
import DepartmentsRepository from './departmentsRepository';
import PermissionsRepository from './PermissionsRepository';
import RolesRepository from './RolesRepository';
import SupplierRepository from './supplierRepository';
import supplierManufactureRepository from './supplierManufactureRepository';
import supplierRawMaterialRepository from './supplierRawMaterialRepository';
import customerRepository from './customerRepository';
import NotificationsRepository from './NotificationsRepository';
import InvoiceRepository from './InvoiceRepository';

const repositories = {
  staff : StaffRepository,
  departments : DepartmentsRepository,
  permissions : PermissionsRepository,
  roles : RolesRepository,
  supplier : SupplierRepository,
  supplierManufacture : supplierManufactureRepository,
  supplierRawMaterial: supplierRawMaterialRepository,
  customer: customerRepository,
  notification: NotificationsRepository,
  invoice: InvoiceRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
